import { CpInlineNotificationIntent } from "./cp-inline-notification.helper";

export const intentStyles: Record<CpInlineNotificationIntent, string> = {
  base: "bg-[var(--cp-color-inline-notification-bg-base)] text-[var(--cp-color-inline-notification-text-base)] border border-[var(--cp-color-inline-notification-border-base)]",
  neutral:
    "bg-[var(--cp-color-inline-notification-bg-neutral)] text-[var(--cp-color-inline-notification-text-neutral)]",
  brand:
    "bg-[var(--cp-color-inline-notification-bg-brand)] text-[var(--cp-color-inline-notification-text-brand)]",
  success:
    "bg-[var(--cp-color-inline-notification-bg-success)] text-[var(--cp-color-inline-notification-text-success)]",
  critical:
    "bg-[var(--cp-color-inline-notification-bg-critical)] text-[var(--cp-color-inline-notification-text-critical)]",
  warning:
    "bg-[var(--cp-color-inline-notification-bg-warning)] text-[var(--cp-color-inline-notification-text-warning)]",
};
